import React from "react"; 
import { BrowserRouter as Router, Routes, Route, useParams, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; 
import Unauthorized from "./components/Unauthorized";
import LoginScreen from "./components/LoginScreen"; 
import { AppSettingsProvider } from "./context/AppSettingsContext";
import ChatPage from "./components/ChatPage";
import EventScribeAuthGuard from "./guard/EventScribeAuthGuard"; 
import AuthGuard from "./guard/AuthGuard"; 
import { AppEnvProvider, useAppEnv } from './context/AppEnvContext'; 
import UnsubscribeSuccess from "./components/UnsubscribeSuccess";
import SessionTimeoutGate from "./components/SessionTimeoutGate";

const ChatWrapper = () => {
  const { token } = useParams(); 
  if (!token) {
    return <Unauthorized />;
  }

  return (
    <SessionTimeoutGate>
      <AppSettingsProvider token={token}>
        <ChatPage token={token} />
      </AppSettingsProvider>
    </SessionTimeoutGate>
  );
};
const ProtectedChatRoute = () => {
  const env = useAppEnv();
  
  // Check if EventScribe guard should be used (value is "1" or "true")
  const useEventScribeGuard = 
    env?.REACT_APP_EVENTSCRIBE_WEBSITE_GUARD === "1" || 
    env?.REACT_APP_EVENTSCRIBE_WEBSITE_GUARD === "true";

  // Conditionally render the appropriate guard
  if (useEventScribeGuard) {
    return (
      <EventScribeAuthGuard>
        <ChatWrapper />
      </EventScribeAuthGuard>
    );
  }

  return (
    <AuthGuard>
      <ChatWrapper />
    </AuthGuard>
  );
};

// New component to handle root route based on flag
const RootRoute = () => {
  const env = useAppEnv();
  
  const isLoginEnabled = 
    env?.REACT_APP_ENABLE_LOGIN_SCREEN === "1" || 
    env?.REACT_APP_ENABLE_LOGIN_SCREEN === "true";

  if (isLoginEnabled) {
    // When login is enabled, redirect root to login
    return <Navigate to="/login" replace />;
  }

  // When login is disabled, show unauthorized (existing behavior)
  return <Unauthorized errorMessage="Please use the direct chat link" />;
};

// Component to conditionally show login
const LoginRoute = () => {
  const env = useAppEnv();
  
  const isLoginEnabled = 
    env?.REACT_APP_ENABLE_LOGIN_SCREEN === "1" || 
    env?.REACT_APP_ENABLE_LOGIN_SCREEN === "true";

  if (!isLoginEnabled) {
    return <Unauthorized errorMessage="Login screen is disabled. Use direct chat links." />;
  }

  return <LoginScreen />;
};
function App() {  
  return (
    <AppEnvProvider>
      <Router>
        <ToastContainer position="top-right" autoClose={1000} style={{ zIndex: 99999 }} /> 

        <Routes>
  
          <Route path="/" element={<RootRoute />} />
          
          {/* Login route - only works when flag is enabled */}
          <Route path="/login" element={<LoginRoute />} />
          
          <Route
            path="/chat/:token"
           element={<ProtectedChatRoute />}
          />
           {/* Catch-all */}
          <Route path="*" element={<Unauthorized />} />
{/* Other routes */}
          <Route path="/unsubscribe-success" element={<UnsubscribeSuccess />} />
        </Routes>
      </Router>
    </AppEnvProvider>
  );
}

export default App;
